import { render, staticRenderFns } from "./FlexibleLayout.vue?vue&type=template&id=8753fe94&scoped=true&v-if=layout.left.length%20%26%26%20layout.center.length%20%26%26%20layout.right.length"
import script from "./FlexibleLayout.vue?vue&type=script&lang=ts"
export * from "./FlexibleLayout.vue?vue&type=script&lang=ts"
import style0 from "./FlexibleLayout.vue?vue&type=style&index=0&id=8753fe94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8753fe94",
  null
  
)

export default component.exports